import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';
import { hotRank } from '@/mocks/site';

const tagPool = newsList.flatMap((item) => item.tags);
const tagCounts = tagPool.reduce<Record<string, number>>((acc, tag) => {
  acc[tag] = (acc[tag] ?? 0) + 1;
  return acc;
}, {});
const popularTags = Object.entries(tagCounts)
  .sort((a, b) => b[1] - a[1])
  .slice(0, 12);

export default function HomeAside() {
  return (
    <div className="flex flex-col gap-4">
      <section
        id="rank"
        aria-labelledby="rank-title"
        className="rounded-lg border border-background-200 bg-background-100"
      >
        <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
          <h2 id="rank-title" className="flex items-center gap-2 font-heading text-lg text-foreground-950">
            <i className="ri-fire-fill text-primary-500" />
            实时热榜
          </h2>
          <span className="text-[11px] text-foreground-500">整点更新</span>
        </div>
        <ol className="p-2">
          {hotRank.map((item) => (
            <li key={item.rank}>
              <Link
                to={`/article/${item.id}`}
                className="group flex items-center gap-3 rounded-md px-3 py-2.5 transition-colors hover:bg-background-200/60"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-sm ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-foreground-800 transition-colors group-hover:text-foreground-950">
                  {item.title}
                </span>
                <span className="shrink-0 text-xs font-label text-accent-500">{item.heat}</span>
              </Link>
            </li>
          ))}
        </ol>
      </section>

      <section
        aria-labelledby="tag-title"
        className="rounded-lg border border-background-200 bg-background-100 p-5"
      >
        <h2 id="tag-title" className="flex items-center gap-2 font-heading text-lg text-foreground-950">
          <i className="ri-price-tag-3-line text-accent-400" />
          热门标签
        </h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {popularTags.map(([tag, count]) => (
            <Link
              key={tag}
              to={`/?q=${encodeURIComponent(tag)}#feed`}
              className="flex items-center gap-1 rounded-full border border-secondary-200/60 bg-secondary-100/70 px-3 py-1.5 text-xs font-label text-secondary-400 transition-colors hover:border-secondary-400 hover:text-secondary-500"
            >
              #{tag}
              <span className="text-foreground-500">{count}</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="rounded-lg border border-background-200 bg-primary-900/40 p-5">
        <h2 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
          <i className="ri-shield-check-line text-primary-400" />
          信息状态说明
        </h2>
        <ul className="mt-4 space-y-3 text-sm text-foreground-600">
          <li className="flex gap-2">
            <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-primary-400" />
            <span>「首发」表示本站较早整理出完整时间线，不代表内容已被证实。</span>
          </li>
          <li className="flex gap-2">
            <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-accent-400" />
            <span>「待确认」代表来源单一或存在冲突，会持续跟进并更新状态。</span>
          </li>
          <li className="flex gap-2">
            <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[6px] text-secondary-400" />
            <span>站内配图均为抽象氛围图，与事件内容无关。</span>
          </li>
        </ul>
        <Link
          to="/about#submit"
          className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-500/50 bg-primary-500/10 px-4 py-2.5 text-sm font-label text-primary-300 transition-colors hover:bg-primary-500/20"
        >
          <i className="ri-send-plane-line" />
          提供线索
        </Link>
      </section>
    </div>
  );
}